var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRateplans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_2361939"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.125 1.175C22.9393 1.175 22.7613 1.24875 22.63 1.38003C22.4988 1.5113 22.425 1.68935 22.425 1.875V8.125C22.425 8.31065 22.4988 8.4887 22.63 8.61997C22.7613 8.75123 22.9393 8.82498 23.1249 8.825C25.2592 8.82742 27.3054 9.67632 28.8145 11.1855C30.3237 12.6946 31.1726 14.7408 31.175 16.8751C31.175 17.0607 31.2488 17.2387 31.38 17.37C31.5113 17.5012 31.6893 17.575 31.875 17.575H38.125C38.3107 17.575 38.4887 17.5012 38.62 17.37C38.7512 17.2387 38.825 17.0607 38.825 16.875C38.825 8.21793 31.7821 1.175 23.125 1.175ZM37.4081 16.175H32.5492C32.3785 13.9187 31.405 11.7972 29.8039 10.1961C28.2028 8.59502 26.0813 7.62149 23.825 7.4508V2.59194C31.154 2.94701 37.053 8.846 37.4081 16.175Z",
    fill: "#202842",
    stroke: "#202842",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.25 3.05H1.175V3.125V4.375V4.45H1.25H2.5H2.575V4.375V3.125V3.05H2.5H1.25Z",
    fill: "#202842",
    stroke: "#202842",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.75 3.05H3.675V3.125V4.375V4.45H3.75H6.875H6.95V4.375V3.125V3.05H6.875H3.75Z",
    fill: "#202842",
    stroke: "#202842",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.0001 4.30001C16.3559 4.29663 12.8258 5.56677 10.0197 7.88974L7.91998 6.31498L7.91997 6.31497C7.7988 6.22412 7.65145 6.17501 7.5 6.17501H1.25H1.175V6.25001V7.50001V7.57501H1.25H7.26668L8.96223 8.8467C7.33019 10.4585 6.07136 12.4089 5.27493 14.5607C4.46838 16.7399 4.15622 19.0711 4.36103 21.3856C4.56585 23.7002 5.28251 25.9404 6.45919 27.944C7.62058 29.9217 9.20145 31.6201 11.09 32.92L9.71007 34.3H1.25H1.175V34.375V35.625V35.7H1.25H10C10.1856 35.7 10.3637 35.6263 10.495 35.495L10.4419 35.442L10.495 35.495L12.3077 33.6823C14.5941 34.9704 17.1677 35.6638 19.7923 35.6986C22.4201 35.7335 25.0142 35.107 27.3361 33.8771L29.58 35.56L29.6232 35.5024L29.58 35.56C29.7012 35.6509 29.8486 35.7 30 35.7H38.125H38.2V35.625V34.375V34.3H38.125H30.2333L28.6382 33.1036C30.7919 31.6846 32.5634 29.7564 33.7953 27.4891C35.0442 25.1905 35.699 22.6161 35.7 20C35.7 19.8144 35.6262 19.6363 35.495 19.505C35.3637 19.3738 35.1856 19.3 35 19.3H28.75C28.5643 19.3 28.3863 19.3738 28.255 19.505C28.1238 19.6363 28.05 19.8144 28.05 20C28.05 21.5921 27.5779 23.1485 26.6933 24.4723C25.8088 25.7962 24.5515 26.828 23.0806 27.4372C21.6097 28.0465 19.9911 28.2059 18.4295 27.8953C16.868 27.5847 15.4336 26.818 14.3078 25.6922C13.182 24.5664 12.4153 23.132 12.1047 21.5705C11.7941 20.0089 11.9535 18.3904 12.5628 16.9194C13.1721 15.4485 14.2038 14.1912 15.5277 13.3067C16.8515 12.4221 18.4079 11.95 20 11.95C20.1857 11.95 20.3637 11.8763 20.495 11.745C20.6262 11.6137 20.7 11.4357 20.7 11.25V5.00001C20.7 4.81436 20.6262 4.63631 20.495 4.50503C20.3637 4.37378 20.1857 4.30003 20.0001 4.30001ZM20.0001 4.30001L20 4.37501M20.0001 4.30001C20 4.30001 20 4.30001 20 4.30001V4.37501M20 4.37501C16.3537 4.37163 12.822 5.64946 10.0221 7.98527L20 4.37501ZM26.6789 26.6787C28.28 25.0777 29.2535 22.9563 29.4242 20.7H34.2831C33.928 28.029 28.029 33.9271 20.7 34.2822V29.4236C22.9563 29.2531 25.0777 28.2797 26.6789 26.6787ZM10.5764 19.3H5.71778C6.07287 11.971 11.971 6.07202 19.3 5.71694V10.5758C17.0437 10.7465 14.9223 11.72 13.3213 13.3211C11.7203 14.9223 10.7469 17.0437 10.5764 19.3ZM19.3 29.4235V34.2821C11.971 33.927 6.073 28.029 5.71792 20.7H10.5765C10.747 22.9562 11.7204 25.0776 13.3214 26.6786C14.9224 28.2796 17.0438 29.253 19.3 29.4235Z",
    fill: "#202842",
    stroke: "#202842",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M36.875 37.425H36.8V37.5V38.75V38.825H36.875H38.125H38.2V38.75V37.5V37.425H38.125H36.875Z",
    fill: "#202842",
    stroke: "#202842",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M30.625 37.425H30.55V37.5V38.75V38.825H30.625H35.625H35.7V38.75V37.5V37.425H35.625H30.625Z",
    fill: "#202842",
    stroke: "#202842",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M1.25 37.425H1.175V37.5V38.75V38.825H1.25H2.5H2.575V38.75V37.5V37.425H2.5H1.25Z",
    fill: "#202842",
    stroke: "#202842",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M3.75 37.425H3.675V37.5V38.75V38.825H3.75H8.75H8.825V38.75V37.5V37.425H8.75H3.75Z",
    fill: "#202842",
    stroke: "#202842",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.625 12.5C25.625 12.3342 25.5591 12.1753 25.4419 12.0581C25.3247 11.9409 25.1658 11.875 25 11.875H22.5C22.3342 11.875 22.1753 11.9409 22.0581 12.0581C21.9409 12.1753 21.875 12.3342 21.875 12.5V13.75H20C19.8342 13.75 19.6753 13.8159 19.5581 13.9331C19.4409 14.0503 19.375 14.2092 19.375 14.375V16.25H17.5C17.3342 16.25 17.1753 16.3159 17.0581 16.4331C16.9409 16.5503 16.875 16.7092 16.875 16.875V18.125H15C14.8342 18.125 14.6753 18.1909 14.5581 18.3081C14.4409 18.4253 14.375 18.5842 14.375 18.75V22.5C14.375 22.6658 14.4409 22.8247 14.5581 22.9419C14.6753 23.0591 14.8342 23.125 15 23.125H25C25.1658 23.125 25.3247 23.0591 25.4419 22.9419C25.5591 22.8247 25.625 22.6658 25.625 22.5V12.5ZM15.625 19.375H16.875V21.875H15.625V19.375ZM18.125 17.5H19.375V21.875H18.125V17.5ZM20.625 15H21.875V21.875H20.625V15ZM24.375 21.875H23.125V13.125H24.375V21.875Z",
    fill: "#202842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.625 12.5C25.625 12.3342 25.5591 12.1753 25.4419 12.0581C25.3247 11.9409 25.1658 11.875 25 11.875H22.5C22.3342 11.875 22.1753 11.9409 22.0581 12.0581C21.9409 12.1753 21.875 12.3342 21.875 12.5V13.75H20C19.8342 13.75 19.6753 13.8159 19.5581 13.9331C19.4409 14.0503 19.375 14.2092 19.375 14.375V16.25H17.5C17.3342 16.25 17.1753 16.3159 17.0581 16.4331C16.9409 16.5503 16.875 16.7092 16.875 16.875V18.125H15C14.8342 18.125 14.6753 18.1909 14.5581 18.3081C14.4409 18.4253 14.375 18.5842 14.375 18.75V22.5C14.375 22.6658 14.4409 22.8247 14.5581 22.9419C14.6753 23.0591 14.8342 23.125 15 23.125H25C25.1658 23.125 25.3247 23.0591 25.4419 22.9419C25.5591 22.8247 25.625 22.6658 25.625 22.5V12.5ZM15.625 19.375H16.875V21.875H15.625V19.375ZM18.125 17.5H19.375V21.875H18.125V17.5ZM20.625 15H21.875V21.875H20.625V15ZM24.375 21.875H23.125V13.125H24.375V21.875Z",
    stroke: "#202842"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M18.125 23.675H18.05V23.75V25V25.075H18.125H19.375H19.45V25V23.75V23.675H19.375H18.125Z",
    fill: "#202842",
    stroke: "#202842",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M15.625 23.675H15.55V23.75V25V25.075H15.625H16.875H16.95V25V23.75V23.675H16.875H15.625Z",
    fill: "#202842",
    stroke: "#202842",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M20.625 23.675H20.55V23.75V25V25.075H20.625H21.875H21.95V25V23.75V23.675H21.875H20.625Z",
    fill: "#202842",
    stroke: "#202842",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M23.125 23.675H23.05V23.75V25V25.075H23.125H24.375H24.45V25V23.75V23.675H24.375H23.125Z",
    fill: "#202842",
    stroke: "#202842",
    strokeWidth: 0.15
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateplans);
export default __webpack_public_path__ + "static/media/rateplans.e829831557cd93ea21231a3d5ebc5e01.svg";
export { ForwardRef as ReactComponent };